import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    dialogContent: {
        width: 'auto',
        minWidth: '300px',
        display: 'flex',
        flexDirection: 'column',
        // minHeight: '300px',
        padding: '12px 24px',
        borderBottom: '2px solid #f0f0f0'
    },
    btnsContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '12px 0',
    },
    descriptionTxt: {
        marginTop: '12px'
    },
    saveBtn: {
        width: '120px',
        marginRight: '12px',
        background: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            background: Colors.DARK_BLUE,
        }
    },
    cancelBtn: {
        width: '120px',
    }
}))

export default useStyles